import { CdkDrag, CdkDragDrop, moveItemInArray, transferArrayItem } from "@angular/cdk/drag-drop";
import { EventEmitter } from "@angular/core";
import { WidgetsComponentAbstract } from "./widgets-component.abstracts";
import { WidgetsContainerAbstract } from "./widgets-container.abstract";
import { WidgetsAbstract } from "./widgets.abstract";

export abstract class WidgetsContainerComponentAbstract extends WidgetsComponentAbstract {
  abstract dropListIds: string[];
  abstract dropListIdAdded: EventEmitter<string>;

  getDroppingPosition(container, element, proposedIndex) {
    if (this.data instanceof WidgetsContainerAbstract) {
      const section = this.data as WidgetsContainerAbstract;
      if (!this.data.isContainerExpanded) {
        proposedIndex = container.data.length;
        this.data.isContainerExpanded = true;
      }
    }
    return proposedIndex;
  }

  onDrop(event: CdkDragDrop<WidgetsAbstract[]>): void {
    try {
      if (event.previousContainer === event.container) {
        // FIXME: Can't move a widget to the middle. Only to the top or bottom
        // FIXME: Maintain dragged widget in place when dragging (now dissapears)
        // TODO: Scroll to top when dragging outside of viewable area

        // Widget has been reordered in canvas
        console.warn("onDrop Widget reordered");
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        this.onWidgetsReordered(event.container.data);
      } else {
        if (event.previousContainer.id === 'widgets-list') {
          // Widget has just been dropped from the palette
          const droppedElement = this.onWidgetDroppedToCanvas(event);

          // If this is a Question AND the section is collapsed, then insert at position length-1
          // We drop the new item at the selected position (event.currentIndex I believe)
          const insertionIndex = this.getDroppingPosition(event.container, droppedElement, event.currentIndex);
          event.container.data.splice(insertionIndex, 0, droppedElement);

          // If new element is a container, add it to the drag&drop container list
          if (droppedElement instanceof WidgetsContainerAbstract) {
            this.onDropListIdAdded(droppedElement.id);
          }

          // reorder automatically after dropping into the canvas
          try {
            this.onWidgetsReordered(event.container.data);
          } catch {
            console.warn("onDrop reorder exception");
          }
        } else {
          // Widget has been moved from one part to another
          // console.warn("onDrop Widget moved");
          let insertionIndex = event.currentIndex;
          if (this.data instanceof WidgetsContainerAbstract) {
            const section = this.data as WidgetsContainerAbstract;
            if (!this.data.isContainerExpanded) {
              const droppedElement = this.onWidgetDroppedToCanvas(event);
              insertionIndex = this.getDroppingPosition(
                event.container,
                droppedElement,
                event.currentIndex
              );
            }
          }
          // cdk drag-drop
          transferArrayItem(
            event.previousContainer.data,
            event.container.data,
            event.previousIndex,
            insertionIndex
          );

          this.onWidgetsReordered(event.container.data);
        }
      }
    } catch (error) {
      console.warn("onDrop " + error);
    }
  }

  onDropListIdAdded(id: string): void {
    this.dropListIdAdded.emit(id);
  }

  abstract onWidgetDroppedToCanvas(event: CdkDragDrop<WidgetsAbstract[]>): WidgetsAbstract;
  abstract isDroppableWidget(item: CdkDrag<WidgetsContainerAbstract>): boolean;
  abstract onWidgetsReordered(culprits: WidgetsAbstract[]);
}
